export const SEO_TITLE_SUFFIX = ' | Menguin' as const;
